// @flow
import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components'

import { lighten, darken } from 'polished'
import hello from 'hello-color'

import colors from '../theme/colors'
import * as _colors from '../theme/_colors'
import mapProps from '../theme/mapProps'
import {
  Headline,
  ContentRow,
  ViewportRow,
  ViewportContainer,
  ViewportContent,
  PageContainer,
  Container,
  Block,
  Fill,
  Flex,
  FlexChild,
  Title,
  Text,
  Paragraph,
  ViewportRibbon
} from '../styleguide'

const ContactContainer = styled(FlexChild)`
  max-width: 32rem;
`

export default (props: any) => (
  <ContentRow>
    <Flex align="center" justify="center">
      <ContactContainer>
        <Title h="2" scale="3" my="0">
          About us
        </Title>
        <Paragraph mb="3" scale="2">
          Velit voluptate fugiat est tempor aliquip adipisicing ea proident non aliquip eiusmod amet esse labore anim pariatur. Qui veniam anim proident Lorem tempor sit consectetur nostrud exercitation incididunt enim veniam amet sit id ipsum. Lorem dolor adipisicing dolore ut enim qui magna laboris aliquip aute culpa. Culpa aute sint labore et quis commodo adipisicing aliquip cupidatat et Lorem do.
        </Paragraph>
      </ContactContainer>
    </Flex>
    <ViewportRibbon/>
  </ContentRow>
)



// WEBPACK FOOTER //
// ./src/pages/about.js